import React from 'react';

import { InfoItemProps } from '../InfoItem';
import { RedemptionCustomCard } from '../RedemptionCustomCard';

export interface RedemptionSuccessProps {
  title?: string;
  infos: InfoItemProps[];
  infoNote?: string;
  onClose: () => void;
  onFollowRedemption: () => void;
}

export const RedemptionSuccess: React.FC<RedemptionSuccessProps> = ({
  infos,
  infoNote,
  onClose,
  onFollowRedemption,
  title = 'Resgate solicitado com sucesso.',
}) => {
  return (
    <RedemptionCustomCard
      iconType="success"
      infos={infos}
      onSecondaryButtonPress={onFollowRedemption}
      onPrimaryButtonPress={onClose}
      title={title}
      infoNote={infoNote}
    />
  );
};
